import React, { useState, useRef } from "react";
import { TextField, SelectField, Option, FormControlLabel, Checkbox, FormLabel, FormControl, Radio, IconButton, Modal, ModalTitle, Typography, ModalContent, Grid,  Tooltip  } from "@deere/fuel-react";
import { getTextTranslation } from "../../../utils/utils";
import { TRANSLATIONS, DEPENDENT_QUESTION, QUESTION_TYPES, DEFAULT_GRID_COLLUMNS, COO_TOOLTIP_DUAL_SOURCE } from "../../../utils/surveyLiterals";
import { ReactComponent as InfoIcon } from "@deere/ux.brand-foundations/icons/info.svg";
import { ReactComponent as AddIcon } from "@deere/ux.brand-foundations/icons/add_circle.svg";
import { ReactComponent as UploadIcon } from "@deere/ux.brand-foundations/icons/upload.svg";

const getQueLabel = (que, currentLang) => {
  const translatedLabel = getTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang, false);
  return que.codeQuestionDepends && que.codeQuestionDepends !== "" ? (
    <>
      <InfoIcon height={18} width={18} title={DEPENDENT_QUESTION} /> {translatedLabel}
    </>
  ) : (
    translatedLabel
  );
};

export const InputOpen = ({ que, currentLang }) => {
  return <TextField sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }} required={que.required} variant="outlined" label={getQueLabel(que, currentLang)} />;
};
export const InputDatePicker = ({ que, currentLang }) => {
  return <TextField sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }} required={que.required} variant="outlined" label={getQueLabel(que, currentLang)} type="date" />;
};
export const InputFile = ({ que, currentLang }) => {
  return <TextField sx={{ "& .MuiInputBase-input": { height: "auto" }, "& .MuiFormLabel-root": { fontSize: "12px" } }} type="file" label={getQueLabel(que, currentLang)} />;
};
export const InputMultiLine = ({ que, currentLang }) => {
  return <TextField sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }} required={que.required} variant="outlined" label={getQueLabel(que, currentLang)} minRows={4} multiline={true} />;
};
export const InputCheck = ({ que, currentLang }) => {
  return (
    <>
      <FormControl fullWidth sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}>
        <FormLabel>{getQueLabel(que, currentLang)}</FormLabel>
      </FormControl>
      {que.selections
        .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
        .map((sel) => (
          <FormControlLabel
            key={sel.code}
            control={<Checkbox />}
            label={getTextTranslation(sel, TRANSLATIONS.toLocaleLowerCase(), currentLang, false)}
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "12px!important" } }}
          />
        ))}
    </>
  );
};
export const InputSelect = ({ que, currentLang }) => {
  return (
    <SelectField label={getQueLabel(que, currentLang)} required={que.required} sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}>
      <Option disabled hidden>
        Select
      </Option>
      {que.selections
        .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
        .map((sel) => (
          <Option key={sel.code} value={sel.code}>
            {getTextTranslation(sel, TRANSLATIONS.toLocaleLowerCase(), currentLang, false)}
          </Option>
        ))}
    </SelectField>
  );
};
export const InputRadio = ({ que, currentLang }) => {
  return (
    <>
      <FormControl fullWidth sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}>
        <FormLabel>{getQueLabel(que, currentLang)}</FormLabel>
      </FormControl>
      {que.selections
        .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
        .map((sel) => (
          <FormControlLabel
            key={sel.code}
            control={<Radio name={que.code} />}
            label={getTextTranslation(sel, TRANSLATIONS.toLocaleLowerCase(), currentLang, false)}
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "12px!important" } }}
          />
        ))}
    </>
  );
};
export const InputViewer = ({ que, currentLang }) => {
  const docName = que.document && que.document.get("fileName") ? que.document.get("fileName") : "";
  return (
    <>
      <FormLabel>{getQueLabel(que, currentLang)}</FormLabel>
      <iframe srcDoc={docName} width={"100%"} height={"150"} />
    </>
  );
};
export const InputCountry = ({ que, currentLang }) => {
  return (
    <SelectField label={getQueLabel(que, currentLang)} required={que.required} sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}>
      <Option disabled hidden>
        Select
      </Option>
    </SelectField>
  );
};
export const InputState = ({ que, currentLang }) => {
  return (
    <SelectField label={getQueLabel(que, currentLang)} required={que.required} sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}>
      <Option disabled hidden>
        Select
      </Option>
    </SelectField>
  );
};

export const InputOpen_Part = ({ que, currentLang }) => {
  return <TextField sx={{ "& .MuiInputBase-input": { fontSize: "10px" } }} />;
};

export const InputSelect_Part = ({ que, currentLang }) => {
  return (
    <SelectField sx={{ "& .MuiInputBase-root": { fontSize: "10px" } }}>
      <Option disabled hidden sx={{ fontSize: "10px" }}>
        Select
      </Option>
      {que.selections
        .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
        .map((sel) => (
          <Option key={sel.code} value={sel.code} sx={{ fontSize: "10px" }}>
            {getTextTranslation(sel, TRANSLATIONS.toLocaleLowerCase(), currentLang, false)}
          </Option>
        ))}
    </SelectField>
  );
};


export const InputSelect_Multi_Country = ({ que, currentLang, setShowCountryModal }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      <Tooltip title={COO_TOOLTIP_DUAL_SOURCE} placement="top">
        <IconButton
          onClick={() => {
            setShowCountryModal(true);
          }}
        >
          <AddIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};


export const InputCheck_Part = ({ que, currentLang }) => {
  return <Checkbox />;
};

export const InputTitlePopup_Part = ({ que, currentLang, questions }) => {
  const [showModal, setShowModal] = useState(false);
  const getCascadingDependentQuestions = (questions, codeQuestion) => {
    const result = [];
    const findDependencies = (code) => {
      const dependencies = questions.filter((q) => q.codeQuestionDepends === code);
      for (const question of dependencies) {
        result.push(question);
        findDependencies(question.code);
      }
    };
    findDependencies(codeQuestion);
    return result;
  };
  const questionsToDisplay = getCascadingDependentQuestions(questions, que.code);
  return (
    <>
      <IconButton onClick={() => setShowModal(true)}>
        <AddIcon />
      </IconButton>
      <ModalCellPopup showModal={showModal} que={que} setShowModal={setShowModal} currentLang={currentLang} questionsToDisplay={questionsToDisplay}/>
    </>
  );
};

export const InputCheckPopup_Part = ({ que, currentLang, questions }) => {
  const [showModal, setShowModal] = useState(false);
  const getCascadingDependentQuestions = (questions, codeQuestion) => {
    const result = [];
    const findDependencies = (code) => {
      const dependencies = questions.filter((q) => q.codeQuestionDepends === code);
      for (const question of dependencies) {
        result.push(question);
        findDependencies(question.code);
      }
    };
    findDependencies(codeQuestion);
    return result;
  };
  const questionsToDisplay = getCascadingDependentQuestions(questions, que.code);
  return (
    <>
      <Checkbox
        onClick={(e) => {
          if (e.target.checked === true) setShowModal(true);
        }}
      />
      <ModalCellPopup showModal={showModal} que={que} setShowModal={setShowModal} currentLang={currentLang} questionsToDisplay={questionsToDisplay}/>
    </>
  );
};

export const InputFile_Part = ({ que, currentLang, questions }) => {
  const fileInputRef = useRef([]);
  const clickHandler = () => {
    fileInputRef.current.value = "";
    fileInputRef.current[que.id].click();
  };
  return (
    <>
      <input
        type="file"
        style={{ display: "none" }}
        ref={(ref) => {
          fileInputRef.current[que.id] = ref;
        }}
      />
      <IconButton onClick={clickHandler} size="small">
        <UploadIcon height={20} width={20} />
      </IconButton>
    </>
  );
};

export const ModalCellPopup = ({ showModal, que, setShowModal, currentLang, questionsToDisplay }) => {
  const getCollumnsByQuestion = (questions, questionsGroup) => {
    const questionsInGroup = questions.filter((q) => q.questionsGroup === questionsGroup);
    return questionsInGroup ? DEFAULT_GRID_COLLUMNS / questionsInGroup.length : DEFAULT_GRID_COLLUMNS;
  };
  return (
    <Modal size="lg" open={showModal} onClose={() => setShowModal(false)} sx={{ "& .MuiPaper-root": { minWidth: "500px" } }}>
      <ModalTitle>
        <Typography variant="h2">{getQueLabel(que, currentLang)}</Typography>
      </ModalTitle>
      <ModalContent>
        <Grid container spacing={2}>
          {questionsToDisplay.map((que) => {
            const collumnsByQuestion = que.questionsGroup ? getCollumnsByQuestion(questionsToDisplay, que.questionsGroup) : DEFAULT_GRID_COLLUMNS;
            return (
              <Grid item xs={collumnsByQuestion} key={que.code} style={{ marginBottom: "20px" }}>
                {que.type === QUESTION_TYPES.NUM || que.type === QUESTION_TYPES.OPEN ? <InputOpen que={que} currentLang={currentLang} /> : <></>}
                {que.type === QUESTION_TYPES.SELECT ? <InputSelect que={que} currentLang={currentLang} /> : <></>}
                {que.type === QUESTION_TYPES.SEL_CNTRY ? <InputCountry que={que} currentLang={currentLang} /> : <></>}
                {que.type === QUESTION_TYPES.SEL_STATE ? <InputState que={que} currentLang={currentLang} /> : <></>}
                {que.type === QUESTION_TYPES.FILE ? <InputFile que={que} currentLang={currentLang} /> : <></>}
              </Grid>
            );
          })}
        </Grid>
      </ModalContent>
    </Modal>
  );
};
